<template>
  <div>
    <div :class="hasIcons ? '' : 'without-icons'">
      <slot name="additional-header" />
      <b-row v-if="hasDescription" no-gutters>
        <b-col>
          <p class="description"
             data-test="info-modal-description"
             v-html="$sanitize($t(`${translation}description`))"
          />
        </b-col>
      </b-row>

      <b-row v-if="Array.isArray(translationInfos)" no-gutters>
        <b-col>
          <div v-for="(info, i) in filteredTranslationInfos"
               :key="i"
               class="info-section d-flex"
               data-test="info-section"
          >
            <sdui-icon v-if="info.icon"
                       variant="primary"
                       bg-variant="primary"
                       :class="'icon-' + info.icon.toLowerCase()"
                       class="md mr-2"
            />
            <p class="mb-0" v-html="$sanitize(info.text)" />
          </div>
          <slot name="additional-content" />
          <SModalPortalTo>
            <b-button size="lg"
                      block
                      variant="primary"
                      data-cy="news-translation-ok"
                      @click="$emit('close')"
            >
              {{ $t('ui.info_modal.cancel') }}
            </b-button>
          </SModalPortalTo>
          <slot name="additional-action" />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import SModalPortalTo from 'src/components/base/SModal/SModalPortalTo.vue'

export default {
  name: 'InfoModal',
  components: { SModalPortalTo },
  props: {
    section: {
      type: String,
      default: '',
    },

    hasIcons: {
      type: Boolean,
      default: true,
    },

    hasDescription: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    translation() {
      return `cardinfo.sections.${this.section}.modal.`
    },

    translationInfos() {
      return this.$tm(`${this.translation}infos`)
    },

    filteredTranslationInfos() {
      return this.translationInfos.filter((info) => {
        const flag = info['only-if-feature-flag']
        if (!flag) return true
        return !!this.$me?.school?.properties?.[flag]
      })
    },
  },

  emits: ['close'],
}
</script>

<style scoped lang="scss">
.description {
  font-weight: $font-weight-bold;
}

.info-section {
  margin-bottom: 20px;
  i {
    height: 50px;
    width: 50px;
    display: block;
    position: relative;
    font-size: pxtorem(45);
    line-height: pxtorem(45);
  }

  p {
    max-width: calc(100% - 55px);
  }
}

.plus-rotate {
  transform: rotate(45deg);
  font-size: pxtorem(33) !important;
  padding-left: 9px;
  padding-top: 9px;
}

.without-icons {
  .description {
    font-size: pxtorem(14);
  }

  .info-section {
    p {
      max-width: 100%;
      margin-left: 0;
      font-size: pxtorem(13);
    }

    .icon {
      display: none !important;
    }
  }
}

.md.icon {
  height: 40px;
  width: 40px;
  font-size: pxtorem(24) !important;
}
</style>
